import useSecurity from "./useSecurity";

export default function useGatsbyAuth() {
	const { loading, error, result } = useSecurity();
	const { authState, authService } = result;

	return { loading, error, authState, authService };
}
